import * as React from 'react'
// import { Link } from 'gatsby'

import IndexLayout from '../layouts';
import Intro from '../components/Intro';
import Features from './Features/FeaturesHeading';
import ContactUs from './ContactUs/ContactUs';
import FeaturesCard from './Features/FeaturesCardPage';
import ClientReview from './ClientReview/ClientReview';
import Pricing from './PricingPage/PricingPage';
import RecordingLogo from '../components/common/RecordingLogo';
import { getThemeProps } from '@material-ui/styles';
<style>
    @import url('https://fonts.googleapis.com/css2?family=Poppins&display=swap');
  </style>
const IndexPage = (props:any) => (
  
  <IndexLayout>
      <Intro />
      <Features description = {props.featuredescription}/>
      <FeaturesCard/>
      <RecordingLogo/>
      <Pricing/>
      <ClientReview/>
      <ContactUs/>
  </IndexLayout>
)

export default IndexPage
